// extracted by mini-css-extract-plugin
module.exports = {"button":"NotFound_button__ht2x_","container-grid":"NotFound_container-grid__czSg7","text":"NotFound_text__qUhII"};